import { Blast } from 'src/app/services/hole.service';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, viewChild, signal, computed } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { Fichier } from '../../bo/fichier';
import { Tir } from '../../bo/tir';
import { WorkflowEtapeInstance } from '../../bo/workflowEtapeInstance';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { DeliveriesService } from '../../services/deliveries.service';
import { Delivery, DeliveryRepports } from '../../bo/delivery';
import { CookieService } from "ngx-cookie-service";
import { ViewEncapsulation } from '@angular/core';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { RegionTemplateReport } from 'src/app/bo/reports/regionTemplateReport';
import { ApiResponse } from 'src/app/bo/apiResponse';

import { Tools } from 'src/app/utils/tools';
import { HoleChargeView } from 'src/app/bo/blastModel/holeChargeView';

import { FileDownloadService } from 'src/app/services/fileDownload.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SelectedShiftColumn } from 'src/app/shared/models/delivery-activity.models';

enum ReportType { BLASTTEMPLATE = 1, DRILLLOG = 2, DELIVERIESLOG = 3, BLAST_QAQC = 4, FEEDBACK = 5 };

interface HoleName {
  name: string
}

class Report {
  constructor(public name: string, public type: ReportType,) {
  }
}

interface ActivityReportContext {
  siteId: number;
  startDate: string;
  endDate: string;
  selectedDates: string[];
  selectedShifts: SelectedShiftColumn[];
  deliveryIds: string[];
  defaultReportName?: string;
}

@Component({
  selector: 'app-rapport-creation-modale',
  templateUrl: './rapport-creation-modale.component.html',
  styleUrls: ['./rapport-creation-modale.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})



export class RapportCreationModaleComponent implements OnInit {
  readonly fileSelect = viewChild<any>('fileSelect');
  
  tir = signal<Tir>(undefined);
  readonly siteId = signal<number>(undefined);
  readonly activityReportContext = signal<ActivityReportContext>(undefined);
  private readonly success = signal<boolean>(false);
  readonly selectedFile = signal<File>(undefined);
  readonly workflowSteps = signal<WorkflowEtapeInstance[]>([]);
  readonly selectedWorkflowStep = signal<WorkflowEtapeInstance>(null);
  readonly templates = signal<Fichier[]>([]);
  readonly deliveries = signal<Delivery[]>([]);
  readonly selectedDeliveryGuid = signal<string>(undefined);
  readonly reportTypes = signal<Report[]>([]);
  readonly areReportTypesLoaded = signal<boolean>(false);
  readonly selectedReport = signal<Report>(null);
  readonly selectedTemplate = signal<RegionTemplateReport>(null);
  readonly selectedAllDeliveries = signal<boolean>(false);
  readonly selectedDeliveries = signal<Delivery[]>([]);
  readonly nomRapport = signal<string>('');
  readonly erreurApi = signal<boolean>(false);
  readonly reportTypeInvalid = signal<boolean>(false);
  readonly nomInvalide = signal<boolean>(false);
  readonly templateInvalid = signal<boolean>(false);
  readonly destinationInvalide = signal<boolean>(false);
  readonly reportsTemplates = signal<RegionTemplateReport[]>([]);
  readonly showError = signal<boolean>(false);
  readonly deliveriesSelectionInvalid = signal<boolean>(false);
  readonly blast = signal<Blast>(undefined);
  readonly holesNames = signal<HoleName[]>([]);
  readonly selectedHoleName = signal<HoleName>(undefined);
  readonly holeChargeView = signal<HoleChargeView>(undefined);
  readonly isBlastFRTemplate = signal<boolean>(undefined);
  readonly isActivityMode = computed<boolean>(() => this.activityReportContext() != undefined);
  readonly isSubmitting = signal<boolean>(false);
  readonly startTimeOptions = signal<string[]>([]);
  readonly endTimeOptions = signal<string[]>([]);
  readonly activityStartTime = signal<string>('');
  readonly activityEndTime = signal<string>('');

  constructor(
    public bsModalRef: BsModalRef,
    private readonly fonctionsService: FonctionsService,
    private readonly http: HttpService,
    private readonly traductionService: TraductionService,
    private readonly deliveriesService: DeliveriesService,
    private readonly cookieService: CookieService,
    private readonly utilService: UtilisateurService,
    private readonly fileDownloadService: FileDownloadService,
    private readonly destroyRef: DestroyRef
  ) {
  }


  ngOnInit() {
    if (this.isActivityMode()) {
      this.initActivityMode();
      return;
    }

    const tirValue = this.tir();
    if (tirValue?.workflowInstance?.workflowEtapeInstances) {
      this.workflowSteps.set(tirValue.workflowInstance.workflowEtapeInstances);
    } else {
      console.warn('workflowInstance or workflowEtapeInstances is null or undefined');
      this.workflowSteps.set([]);
    }
   
    this.nomRapport.set(tirValue.nom);
    this.populateReportList();
    this.getTemplatesForRegion();

    // this.holeService.GetHolesNamesWithCharge(this.tir().tirId).then((response:string[]) => {
    //   if(response){
    //     this.holesNames.set(response.map(n =>  ({ name: n })));
    //       }
    //    })

  }


  onFileSelected(event: any): void {
    if(!Tools.isValidImageType(event.target.files[0])){
      this.traductionService.translate.get('GEODATA.UNAUTHORIZED_FORMAT').subscribe(trad => {
        this.fonctionsService.launch_toast(false,false, trad);
        this.fileSelect().nativeElement.value = '';
        return;
        });
    }
    this.selectedFile.set(event.target.files[0]);
  }
  
  onSubmit(nomTir: string) {
    if (this.isSubmitting()) {
      return;
    }
    this.erreurApi.set(false);
    if (this.validationFormulaire()) {
      this.isSubmitting.set(true);
      if (this.isActivityMode()) {
        this.downloadActivityDeliveriesZip();
        return;
      }

      switch (this.selectedReport().type) {
        case ReportType.BLAST_QAQC:
          let url:string;
          if(this.selectedWorkflowStep() != null)
          {
            let workflowStepIdParam = `stepId=${this.selectedWorkflowStep().workflowEtapeInstanceId}`;
            url = `reports/${this.tir().tirId}/qaqcReport?&${workflowStepIdParam}`
          }
          else
          {
            url = `reports/${this.tir().tirId}/qaqcReport`
          }
          this.fileDownloadService.downloadFile(url, this.nomRapport() + 'qaqc.xlsx');
          this.bsModalRef.hide();
          setTimeout(() => {
            this.utilService.notifyFilesRefresh();
          }, 1000);
          break;
        default:
          this.fonctionsService.loading_screen(true);
          this.bsModalRef.hide();
          let queryUrl = this.buildQueryUrl(nomTir);
          this.executeGetQuery(queryUrl);
      }
      
    }
  }

  private buildQueryUrl(nomTir: string): string | null {
    const timeDateNow = this.fonctionsService.getDataTimeLocalNow();
    let language = this.cookieService.get('epcLanguage') || 'en'; // Default to English if no cookie is set
  
    if (!this.selectedReport()) return null;
    let basePath = `reports/`;
    let workflowStepIdParam = `stepId=${this.selectedWorkflowStep().workflowEtapeInstanceId}`;
    let fileNameWithTimestampParam = `userFileName=${nomTir}_${timeDateNow}`;

    switch (this.selectedReport().type) {
      case ReportType.DRILLLOG:
        var queryParams = `language=${language}&${workflowStepIdParam}&${fileNameWithTimestampParam}`;
        return `${basePath}${this.tir().tirId}/drilllog?${queryParams}`;

      case ReportType.DELIVERIESLOG:
        basePath += this.selectedAllDeliveries() ? 'alldeliverieslog' : 'deliverieslog';
        var userPathOneDelivery = `userFileName=${nomTir}`;
        var queryParams = `tirId=${this.tir().tirId}`;
        if (this.selectedAllDeliveries()) {
          return `${basePath}?${queryParams}&${workflowStepIdParam}&${fileNameWithTimestampParam}`;
        }
        return `${basePath}?${queryParams}&${workflowStepIdParam}&deliveryGuid=${this.selectedDeliveryGuid()}&${userPathOneDelivery}`;
      
      case ReportType.FEEDBACK:
        var tirsIdParam = `tirsId=${this.tir().tirId}`;
        return `${basePath}${this.tir().siteId}/feedback?${workflowStepIdParam}&${tirsIdParam}`;

      default:
        return null; // Return null if the report type is unsupported
    }
  }

  private executeGetQuery(queryUrl: string): void {
    this.http.get<ApiResponse<boolean>>(queryUrl)
      .subscribe({
        next: (response) => this.handleApiResponse(response),
        error: (error) => this.handleApiError(error)
      });
  }

  private handleApiResponse(response: ApiResponse<boolean>): void {
    this.fonctionsService.loading_screen(false);
    if (response && (response.statusCode === 200 || response.statusCode === undefined)) {
      this.success.set(true);
      this.fonctionsService.launch_toast(true);
      this.utilService.notifyFilesRefresh();
    } else {
      this.erreurApi.set(true);
      this.fonctionsService.launch_toast(false, false, response?.message || 'An error occurred');
    }
  }

  private handleApiError(error: any): void {
    console.error('API Error:', error);  // Log error details for debugging
    this.erreurApi.set(true);
    this.fonctionsService.loading_screen(false);
    this.fonctionsService.launch_toast(false, false, 'Failed to process your request.');
  }

  public onSelectReportType(d: Delivery) {
    this.selectedDeliveryGuid.set(d.deliveryId);
    var delivery = this.deliveries().find(delivery => delivery.deliveryId === d.deliveryId);
    if (undefined !== delivery) {
      let deliveryDate = new Date(delivery.startTime);
      let blastTime = deliveryDate.toLocaleTimeString();
      blastTime = blastTime.replace(/:/ig, "-");
      this.nomRapport.set(this.tir().nom);
    }
  }

  protected selectedTemplateChange(){
     this.isBlastFRTemplate.set(this.selectedTemplate().templateName === "tir_template.trdp");
  }

  protected selectedTemplateClear(){
    this.selectedTemplate.set(undefined);
    this.isBlastFRTemplate.set(false);
  }

  private validationFormulaire(): boolean {
    var reportTypes = [ReportType.BLASTTEMPLATE, ReportType.DRILLLOG, ReportType.DELIVERIESLOG, ReportType.BLAST_QAQC, ReportType.FEEDBACK];
    this.nomInvalide.set(this.fonctionsService.stringEstVide(this.nomRapport()));
    this.destinationInvalide.set(!this.isActivityMode() && !(this.selectedWorkflowStep() != null && this.selectedWorkflowStep() != undefined) && (this.selectedReport().type != ReportType.BLAST_QAQC));
    this.deliveriesSelectionInvalid.set(false);
    this.reportTypeInvalid.set(true);

    if(this.selectedReport() && reportTypes.includes(this.selectedReport().type)){
          if(this.selectedReport().type === ReportType.BLASTTEMPLATE){
            this.templateInvalid.set(!this.selectedTemplate());
          }

          if (this.isActivityMode() && this.selectedReport().type === ReportType.DELIVERIESLOG) {
            this.deliveriesSelectionInvalid.set(this.selectedDeliveries().length === 0);
          }

          this.reportTypeInvalid.set(false);
    }
    
    return !(this.nomInvalide() || this.templateInvalid() || this.destinationInvalide() || this.deliveriesSelectionInvalid()) ;
  }

 private populateReportList() {
    this.reportTypes.set([]);
    const traduction = this.traductionService.translate.instant([
      'RAPPORT_TIR.BLAST_REPORT',
      'RAPPORT_TIR.DRILL_REPORT',
      'RAPPORT_TIR.DELIVERIES_REPORT',
      'RAPPORT_TIR.BLAST_QAQC'
    ]);

    const currentReports = [
      new Report(traduction['RAPPORT_TIR.BLAST_REPORT'], ReportType.BLASTTEMPLATE),
      new Report(traduction['RAPPORT_TIR.DRILL_REPORT'], ReportType.DRILLLOG),
      new Report(traduction['RAPPORT_TIR.BLAST_QAQC'], ReportType.BLAST_QAQC)
    ];
    this.reportTypes.set(currentReports);
    this.areReportTypesLoaded.set(true);

    this.deliveriesService.getDeliveriesByTirId(this.tir().tirId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (deliveries) => {
        if (deliveries) {
          const sortedDeliveries = (deliveries as Delivery[]).sort((a, b) => 
            a.startTime > b.startTime ? 1 : a.startTime < b.startTime ? -1 : 0
          );
          this.deliveries.set(sortedDeliveries);

          if (sortedDeliveries.length > 0) {
            this.reportTypes.set([
              ...this.reportTypes(),
              new Report(traduction['RAPPORT_TIR.DELIVERIES_REPORT'], ReportType.DELIVERIESLOG)
            ]);
          }
        }
      },
      error: (error) => {
        console.error('Erreur lors du chargement des deliveries:', error);
      }
    });
  }

  private getTemplatesForRegion() {
    
  }

  protected onActivityDeliveriesChange(deliveries: Delivery[] | null): void {
    this.selectedDeliveries.set(deliveries ?? []);
  }

  private initActivityMode(): void {
    const context = this.activityReportContext();
    if (!context) {
      return;
    }

    this.siteId.set(context.siteId);

    const traduction = this.traductionService.translate.instant([
      'RAPPORT_TIR.DELIVERIES_REPORT',
    ]);

    const deliveriesReport = new Report(
      traduction['RAPPORT_TIR.DELIVERIES_REPORT'],
      ReportType.DELIVERIESLOG,
    );

    this.reportTypes.set([deliveriesReport]);
    this.selectedReport.set(deliveriesReport);
    this.areReportTypesLoaded.set(true);
    this.selectedAllDeliveries.set(true);
    this.nomRapport.set(context.defaultReportName || 'Delivery_reports');
    this.startTimeOptions.set(this.buildHourOptions());
    this.endTimeOptions.set(this.buildHourOptions());

    if (context.selectedShifts.length === 1) {
      const selectedShift = context.selectedShifts[0];
      this.activityStartTime.set(this.formatHour(selectedShift.startHour));
      this.activityEndTime.set(this.formatHour(selectedShift.endHour));
    } else {
      this.activityStartTime.set('');
      this.activityEndTime.set('');
    }

    const selectedIds = new Set(context.deliveryIds);
    const startDate = new Date(context.startDate);
    const endDate = new Date(context.endDate);

    this.deliveriesService
      .getDeliveriesBySiteId(context.siteId, startDate, endDate)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (deliveries) => {
          const filtered = (deliveries ?? [])
            .filter(delivery => selectedIds.has(delivery.deliveryId))
            .sort((a, b) =>
              a.startTime > b.startTime ? 1 : a.startTime < b.startTime ? -1 : 0,
            );

          this.deliveries.set(filtered);
          this.selectedDeliveries.set(filtered);
        },
        error: (error) => {
          console.error('Erreur lors du chargement des deliveries activity mode:', error);
        },
      });
  }

  private downloadActivityDeliveriesZip(): void {
    const context = this.activityReportContext();
    if (!context) {
      return;
    }

    const selectedIds = this.selectedDeliveries().map(delivery => delivery.deliveryId);
    if (selectedIds.length === 0) {
      this.deliveriesSelectionInvalid.set(true);
      return;
    }

    this.fonctionsService.loading_screen(true);

    const payload = new DeliveryRepports(false);
    payload.deliveryIds = selectedIds;

    this.http.downloadFilePost(`Reports/${context.siteId}/getzip`, payload).subscribe({
      next: (resultat: any) => {
        const blob = new Blob([resultat], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const fileName = `${this.sanitizeFileName(this.nomRapport()) || 'Delivery_reports'}.zip`;

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();

        setTimeout(() => {
          anchor.remove();
          window.URL.revokeObjectURL(url);
          this.fonctionsService.loading_screen(false);
        }, 100);

        this.bsModalRef.hide();
      },
      error: () => {
        this.fonctionsService.loading_screen(false);
        this.traductionService.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
          this.fonctionsService.launch_toast(false, false, trad);
        });
      },
    });
  }

  private sanitizeFileName(value: string): string {
    return value.replace(/[\\/:*?"<>|]+/g, '_').trim();
  }

  private buildHourOptions(): string[] {
    return Array.from({ length: 24 }, (_, hour) => this.formatHour(hour));
  }

  private formatHour(hour: number): string {
    const normalized = ((hour % 24) + 24) % 24;
    return `${String(normalized).padStart(2, '0')}:00`;
  }



}
